import { hasStylesToRemove } from "@azu-business/editor-v3";
import { AitCellData } from "aic";
import { STYLES_TO_CLEAN, STYLES_TO_DELETE } from "../../../config";

/**
 * Checks if a table cell contains any Optional or Notes styles in its text or comments.
 *
 * @template T - Content type for the cell text and comments
 * @param cell - The cell whose text and comments are inspected for styles
 * @returns True if the cell text or comments contain styles to remove, false otherwise
 */
export const hasStylesInCell = <T>(cell: AitCellData<T>): boolean => {
  const stylesToCheck = [...STYLES_TO_DELETE, ...STYLES_TO_CLEAN];
  const hasStylesInText = hasStylesToRemove(cell.text, stylesToCheck);
  const hasStylesInComments = hasStylesToRemove(cell.comments, stylesToCheck);
  return hasStylesInText || hasStylesInComments;
};
